export const PlansEntryReason = {
    ApplicationEntry: 'application-entry',
    BackNavigation: 'back-navigation',
    SoftToHardTransition: 'soft-to-hard-transition',
    WorkflowReset: 'workflow-reset',
    UpdateOffer: 'update-offer',
    ChangeOrder: 'change-order',
    AuthorizePlanEdit: 'authorize-plan-edit',
    Unknown: 'unknown',
} as const;

export type PlansEntryReasonValue = (typeof PlansEntryReason)[keyof typeof PlansEntryReason];
